import { forwardRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Node } from 'reactflow';
import Select from 'react-select';
import { NodeData, Position } from '../../../pages/campaings/flows/types';
import Input from '../../forms/input.component';
import TextArea from '../../forms/text-area.component';
import InvalidFeedback from '../../forms/invalid-feedback.component';

interface RedirectAgentNodeFormProps {
  node: Node<NodeData>;
  onSave: (nodeId: string, data: NodeData, position: Position) => void;
}

const RedirectAgentNodeForm = forwardRef<HTMLFormElement, RedirectAgentNodeFormProps>(
  ({ node, onSave }, ref) => {
    const {
      control,
      register,
      handleSubmit,
      formState: { errors }
    } = useForm<NodeData>({
      defaultValues: node.data,
      mode: 'onChange'
    });

    const onSubmit = (data: NodeData) => {
      onSave(node.id, data, node.position);
    };

    return (
      <form ref={ref} onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
          <Input
            label="Título del nodo"
            {...register('title', { required: 'Este campo es requerido' })}
            error={errors.title?.message}
          />
        </div>

        <div className="mb-3">
          <TextArea
            label="Mensaje de redirección"
            rows={3}
            {...register('redirect_agent.message.es', {
              required: 'El mensaje es requerido',
              maxLength: { value: 1024, message: 'Máximo 1024 caracteres' }
            })}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Agentes</label>
          <Controller
            name="redirect_agent.agents"
            control={control}
            rules={{
              validate: (v) => (Array.isArray(v) && v.length > 0) || 'Ingresa al menos un agente'
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              const options = (value || []).map((v) => ({ label: v, value: v }));
              return (
                <>
                  <Select
                    isMulti
                    options={options}
                    className={error ? 'form-select-custom is-invalid' : 'form-select-custom'}
                    classNamePrefix="form-select-custom"
                    placeholder="Selecciona agentes"
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? `Sin opciones para '${inputValue}'` : 'Sin opciones'
                    }
                    onChange={(items) => onChange(items.map((i) => i.value))}
                    value={options}
                    menuPosition="fixed"
                  />
                  <InvalidFeedback error={error} />
                </>
              );
            }}
          />
        </div>
      </form>
    );
  }
);

export default RedirectAgentNodeForm;
